import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { FormControl } from 'react-bootstrap';
import CommonButton from '../atoms/CommonButton';

const styles = {};

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  },
  headerContainer: {
    fontSize: 23,
    color: '#fff',
    fontWeight: 500,
    backgroundColor: '#9A9A9A',
    textAlign: 'center',
    padding: 20
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 0
  },
  row: {
    padding: 20,
    paddingLeft: 25,
    paddingRight: 25
  },
  col1: {
    alignSelf: 'center'
  },
  col2: {
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'right',
    alignSelf: 'center'
  },
  formControl: {
    minHeight: 40,
    borderRadius: 4,
    borderColor: '#ccc',
    fontSize: 16,
    textAlign: 'right',
    width: '100%',
    boxShadow: 'none'
  },
  alertTextBox: {
    color: '#FF3939',
    fontSize: 12,
    backgroundColor: '#FFFAC9',
    padding: 20,
    marginTop: 10,
    marginBottom: 10
  }
});

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    okAction,
    isSmall,
    budget,
    newBudgetAmount,
    setNewBudgetAmount
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    const classes = useStyles();
    const sumBudget =
      Number((budget && budget.budgetAmount) || 0) +
      Number(newBudgetAmount || 0);
    const oldBudget = (budget && budget.budgetAmount) || 0;
    const month = budget && budget.budgetMonth.split('/')[1];
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <div className={classes.headerContainer}>
          <IconButton
            aria-label="close"
            onClick={cancelAction}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
          <div className="fs-23 text-white font-weight-medium">
            {`{${month}月}`}
            予算修正
          </div>
        </div>
        <DialogContent>
          <Grid container className={classes.row}>
            <Grid item xs={6} className={classes.col1}>
              承認済み金額
            </Grid>
            <Grid item xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid item xs={5}>{`{${oldBudget.toLocaleString()}}`}</Grid>
          </Grid>
          <Grid container className={classes.row}>
            <Grid item xs={6} className={classes.col1}>
              追加希望金額
            </Grid>
            <Grid item xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid item xs={5}>
              <FormControl
                type="text"
                className={classes.formControl}
                value={newBudgetAmount}
                onChange={e => {
                  const value =
                    parseInt(e.target.value.replace(/[^\d]/, ''), 0) || '';

                  if (value > 100000000) {
                    alert('予算の上限額を超えました。やり直してください。');
                  } else {
                    setNewBudgetAmount(value);
                  }
                }}
              />
            </Grid>
          </Grid>

          <hr />

          <Grid container className={classes.row}>
            <Grid item xs={6} className={classes.col1}>
              追加後金額
            </Grid>
            <Grid item xs={1} className={classes.col2}>
              ￥
            </Grid>
            <Grid item xs={5}>{`{${sumBudget.toLocaleString()}}`}</Grid>
          </Grid>

          <div className={classes.alertTextBox}>
            ※すでに承認された金額を減額することはできません
            <br />
            ※申請後承認されるとチケット利用が可能です
            <br />
            ※毎月月末14時以降の申請は受け付けができませんのでご注意ください
          </div>
        </DialogContent>
        <DialogActions>
          <CommonButton
            disabled={newBudgetAmount === ''}
            title="申請する"
            onClickAction={() => okAction(sumBudget)}
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
